import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController, Platform } from "@ionic/angular";
import { Subscription } from "rxjs";

import { StaticClass } from "src/components/shared-components/class/general-classes/static-classes";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";
import { ConnectionType } from "src/components/shared-components/enum/enumSettings";
import { iDevicesKnown } from "src/model/interface/iDevicesKnown";
import { EventService } from "src/service/event.service";
import { NetworkService } from "src/service/network.service";
import { ThemeService } from "src/service/theme.service";
import { Device } from "src/components/shared-components/class/general-classes/device";

@Component({
    selector: "app-popup-associate-existing-sinapsi-device",
    templateUrl: "./popup-associate-existing-sinapsi-device.html",
    styleUrls: ["./popup-associate-existing-sinapsi-device.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupAssociateExistingSinapsiDevice implements OnInit, OnDestroy {
  private _eventSubscriptions: Array<Subscription> = null;

  public searchText: string = "";
  public toolbarCssClass: string = "";
  public isMobileDevice: boolean = false;
  public listDevices: Device[] = [];
  public toolBarColor: string = "primary";
  public deviceSearchText: string = "";

  @Input() isSelectedAddDevice: boolean;
  @Input() idArea: number;
  @Input() idEnvironment: number;
  @Input() devices: Device[];
  @Input() listKnownDevices: iDevicesKnown[];

  constructor(
    private _eventService: EventService,
    private _modalController: ModalController,
    private _platform: Platform,
    private _themeService: ThemeService,
    private _networkService: NetworkService
  ) { }

  ngOnInit(): void {
    this.checkMobileCondition();
    this.subscribeEvents();

    if (this.devices?.length > 0) {
      this.listDevices = [...this.devices];
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  /**
   * Close the modal and retain the main page
   */
  public closePopupAssociateDevices() {
    this._modalController.dismiss();
  }

  /**
   * Handle the dismissing of the modal overlay with the selected device to associate
   * @param device selected sinapsi device to associate
   */
  public onClickAddUnassociatedDevice(device) {
    this._modalController.dismiss(device);
  }

  /**
   * Get the navigation params as string
   * @returns string
   */
  public getNavigationParamsBack(): string {
    const idAreaString: string = this.idArea?.toString();
    const idEnvironmentString: string = this.idEnvironment?.toString();
    return `${idAreaString}/${idEnvironmentString}`;
  }

  /**
   * Get the known device associated to a specific Sinapsi device
   * @param idVimarDevice idVimarDevice
   */
  public getKnownDevice(idVimarDevice: number) {
    const knownDevice = this.listKnownDevices.filter(
      (device) => device.id === idVimarDevice
    );

    return knownDevice[0];
  }

  /**
   * Check mobile condition.
   * It load app version and it sets size of floating container
   */
  private checkMobileCondition(): void {
    this.isMobileDevice =
      this._platform.is("ios") || this._platform.is("android");

    if (this.isMobileDevice) {
      this.toolbarCssClass = "force-show-top-toolbar";
    } else {
      this.toolbarCssClass = "force-hide-top-toolbar";
    }
  }

  /**
   * Subscribe to event-service observable
   */
  private subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
    const networkServiceSubscription: Subscription =
      this._networkService.currentConnectionType.subscribe(
        (currentConnectionType: ConnectionType) => {
          this.toolBarColor = StaticClass.getComponentColorByNetworkState(
            currentConnectionType
          );
        }
      );
    this._eventSubscriptions.push(networkServiceSubscription);
  }

  /**
   * Unsubscribe from all subscriptions
   */
  private unsubscribeEvents(): void {
    this._eventSubscriptions.map((subscription) => subscription.unsubscribe());
  }
}
